import { useLazyQuery } from '@apollo/client';
import { useLocale } from '..';
import { FIELD_OPTION } from '../graphql';
export const useFieldOption = ({ extraData } = {}) => {
    const { t } = useLocale();
    const [fetch, { data, loading, error }] = useLazyQuery(FIELD_OPTION, {});
    const fieldOption = (data?.fieldOption || {});
    const fetchFieldOption = async ({ clientId, entityType, fieldCode, query, fetchAll = false, ids = [], pagination = {
        page: 1,
        pageSize: 2000,
    }, orderBy, orderByDir, }) => {
        const result = await fetch({
            variables: {
                spec: {
                    clientId,
                    entityType: entityType.toUpperCase(), // the enum is not uppercase in types, but should be when passing to graphql
                    fieldCode,
                    value: query,
                    fetchAll,
                    ids,
                    ...(extraData || {}),
                    ...(pagination ? { pagination } : {}),
                    ...(orderBy ? { orderBy } : {}),
                    ...(orderByDir ? { orderByDir } : {}),
                },
            },
        });
        const items = result.data?.fieldOption?.options?.items || [];
        const page = result.data?.fieldOption?.options?.page || 1;
        const pageSize = result.data?.fieldOption?.options?.pageSize || 2000;
        const total = result.data?.fieldOption?.options?.total || 0;
        const fieldOption = {
            ...result.data?.fieldOption,
            options: (items || []).map(opt => ({
                ...opt,
                label: opt.localize ? t(opt.label) : opt.label,
            })),
        };
        return { fieldOption, items, page, pageSize, total };
    };
    return {
        fieldOption,
        loading,
        error,
        fetchFieldOption,
    };
};
